import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { BrowserCompatibilityService } from '../services/browser-compatibility.service';

// Usage in routing module:
// {
//   path: 'dashboard',
//   component: DashboardComponent,
//   canActivate: [BrowserSupportGuard]
// }
@Injectable({
  providedIn: 'root'
})
export class BrowserSupportGuard implements CanActivate {
  
  constructor(
    private browserService: BrowserCompatibilityService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const result = this.browserService.checkBrowserSupport();
    
    if (!result.isSupported) {
      // Redirect to browser warning page or block navigation
      window.location.href = '/browser-check';
      return false;
    }
    
    return true;
  }
}
